import api from '@/api/api'
import router from '@/router/index'
import { normalize, schema } from 'normalizr'
import { reserva } from '@/store/reservas/_id/store'
import contratosKyc from './contratosKyc/store'

export const comprador = new schema.Entity('comprador')
const replacer = (key, value) => typeof value === 'undefined' ? null : value

export default {
  namespaced: true,
  modules: {
    contratosKyc
  },
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    },
    updateSet (state, payload) {
      state.list = Object.assign({}, state.list, payload.comprador)
    }
  },
  actions: {
    loadAll ({ dispatch }, id) { // Devuelve todas las facturas
      return new Promise((resolve, reject) => {
        api.get('/compradores/get_lista', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificar ({ dispatch }, {id, compradores, completado, simplificada}) {
      return new Promise((resolve, reject) => {
        api.post('/compradores/modificar', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              compradores,
              completado,
              simplificada
            }
          }, replacer)
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarDesdeContrato ({ commit, dispatch }, {id, compradores}) {
      return new Promise((resolve, reject) => {
        api.post('/compradores/modificar_desde_contrato', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              compradores
            }
          }, replacer)
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data.compradores, [comprador])
              commit('updateSet', normalizedData.entities)
              let normalizedDataReserva = normalize(response.data.result.data.data.reserva, reserva)
              commit('reservas/updateSet', normalizedDataReserva.entities, { root: true })
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarEmailsTelefonos ({ dispatch }, {id, compradores}) {
      return new Promise((resolve, reject) => {
        api.post('/compradores/modificar_emails_telefonos', {
          jsondata: JSON.stringify({
            parametros: {
              id,
              compradores
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              dispatch('reservas/_id/cargarDatosNormalizados', response.data.result.data.data, {root: true})
              .then(() => {
                resolve()
              })
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    rechazarKyc ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/validacionDocumentacion/rechazar_kyc', {
          jsondata: JSON.stringify({
            parametros: {
              id: obj.id,
              validacion: obj.validacion,
              titularId: obj.titularId,
              compradores: obj.compradores
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    escanearDni ({ dispatch }, backImg) {
      return new Promise((resolve, reject) => {
        api.post('/compradores/escanear_dni', {
          jsondata: JSON.stringify({
            parametros: {
              backImg
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/compradores/store.js